import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { ScrollToTop } from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Features from "@/pages/Features";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Vendors from "@/pages/Vendors";
import Help from "@/pages/Help";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { PrivacyPage, TermsPage, RefundPage, AccountDeletionPage } from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/features" element={<Features />} />
            <Route path="/home-services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/for-service-professionals" element={<Vendors />} />
            <Route path="/help" element={<Help />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund-policy" element={<RefundPage />} />
            <Route path="/account-deletion" element={<AccountDeletionPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
